module.exports = __webpack_public_path__ + "static/media/new-developer.07fcf72b.svg";